import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate, Link } from 'react-router-dom';
import { portfolioItems } from './data'; 

const filters = ['All', 'Aluminum', 'Steel'];

export default function Portfolio() {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 15;

  const filteredItems =
    activeFilter === 'All'
      ? portfolioItems
      : portfolioItems.filter(item => item.category === activeFilter);

  // Calculate pagination
  const totalPages = Math.ceil(filteredItems.length / productsPerPage);
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredItems.slice(indexOfFirstProduct, indexOfLastProduct);

  // Handle page changes
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  // Reset to first page when filter changes
  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
    setCurrentPage(1);
  };

  return (
    <>
        <div className="page-title light-background">
        <div className="container d-lg-flex justify-content-between align-items-center">
            {/* <h1 className="mb-2 mb-lg-0">Product Category</h1> */}
            <nav className="breadcrumbs">
            <ol>
                <li><Link to="/">Home</Link></li>
                <li className="current">Product</li>
            </ol>
            </nav>
        </div>
        </div>
        <section id="portfolio" className="portfolio section py-5">
        <div className="container">
            {/* Filter Buttons */}
            <ul className="nav justify-content-center mb-4">
            {filters.map(filter => (
                <li className="nav-item mx-2" key={filter}>
                <button
                    className={`btn btn-sm ${
                    activeFilter === filter ? 'filter-pri ' : ''
                    }`}
                    onClick={() => handleFilterChange(filter)}
                >
                    {filter}
                </button>
                </li>
            ))}
            </ul>

            {/* Portfolio Grid */}
            <div className="row g-4">
            <AnimatePresence mode="wait">
                {currentProducts.map(item => (
                <motion.div
                    key={item.title + item.img}
                    className="col-md-6 col-lg-4"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 0.8 }}
                    transition={{ duration: 0.4, ease: 'easeInOut' }}
                >
                    <div className="card shadow-sm border-0 h-100" onClick={() => navigate(`/product/${item.img}`)}>
                    <img
                                // src="/images/MainProduct/app1.jpg"
                        src={item.image.MainImage}
                        className="card-img-top"
                        alt={item.title}
                    />
                    <div className="card-body d-flex justify-content-between align-items-center position-relative">
                      <h5 className="card-title mb-0 mx-auto title-transition">{item.title}</h5>
                      <button className="btn btn-sm view-details" onClick={() => navigate(`/product/${item.img}`)}>View Details</button>
                    </div>

                    </div>
                </motion.div>
                ))}
            </AnimatePresence>
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center mt-5">
                <div className="pagination-controls" style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <button 
                    className="btn btn-prv btn-primary"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                    style={{ 
                      opacity: currentPage === 1 ? 0.5 : 1,
                      cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                    }}
                  >
                    <i className="fas fa-chevron-left me-2"></i>
                    Previous
                  </button>
                  
                  <span className="mx-3">
                    Page {currentPage} of {totalPages}
                  </span>
                  
                  <button 
                    className="btn btn-nxt btn-primary"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                    style={{ 
                      opacity: currentPage === totalPages ? 0.5 : 1,
                      cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                    }}
                  >
                    Next
                    <i className="fas fa-chevron-right ms-2"></i>
                  </button>
                </div>
              </div>
            )}
        </div>
        </section>
    </>
  );
}